module.exports = __webpack_public_path__ + "static/media/grey.3f5d2d9c.png";